module.exports = __webpack_public_path__ + "static/media/Archived.adab7271.png";